import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import './testimonials.css';

import testimonialImg from '../../assets/images/review1.png';
import Slider from 'react-slick';

const Testimonials = (props) => {
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    return (
        <section>
            <Container>
                <Row>
                    <Col lg="12" className="m-auto">
                        <div className="slider__wrapper d-flex align-items-center justify-content-between gap-10">
                            <div className="slider__content ">
                                <h2 className="mb-4">{props.titleParagraph}</h2>
                                <Slider {...settings}>
                                    <div>
                                        <div className="single__testimonial">
                                            <p className="review__content">
                                                Lorem ipsum dolor sit, amet consectetur adipisicing
                                                elit. Optio facere nostrum, praesentium quidem
                                                voluptatem, et recusandae repellendus, officiis a
                                                accusamus nemo necessitatibus pariatur esse neque.
                                                Aliquam doloribus adipisci incidunt eos rerum!
                                                Consectetur sapiente aspernatur commodi expedita
                                                animi praesentium voluptatibus. Illum eveniet dolore
                                                nemo quisquam asperiores tempore magni magnam
                                                dolorum? Nisi.
                                            </p>
                                            <h6>Jhon Doe</h6>
                                            <p>Web Developer</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="single__testimonial">
                                            <p className="review__content">
                                                Lorem ipsum dolor sit, amet consectetur adipisicing
                                                elit. Nisi, sint error eligendi aspernatur
                                                accusantium sapiente laborum, alias earum facere
                                                nihil ipsum sit temporibus provident recusandae
                                                maxime. Veniam labore error voluptatibus animi quod
                                                enim eius vel!
                                            </p>
                                            <h6>Jhon Doe</h6>
                                            <p>Web Developer</p>
                                        </div>
                                    </div>
                                </Slider>
                            </div>

                            <div className="slider__img">
                                <div className="w-60">
                                    <img src={testimonialImg} alt="" className="w-100" />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Testimonials;
